import { Badge } from "antd";
import { CapitalizeString } from "../../../../../base/utils";
import styles from "./ContentItem.module.css";
import { COLORS } from "../../../../../base/style";
import styled from "styled-components";
import { LangLink } from "../../../LangLink/LangLink";

const StyledDiv = styled.div`
  order: ${(props) => props.order};
`;

const ContentItem = ({
  title,
  children,
  order,
  external_link,
  internal_link,
}) => {
  return (
    <StyledDiv className={styles.ContentItem} order={order}>
      <Badge.Ribbon
        text={
          external_link ? (
            <a
              className={styles.ContentText}
              href={external_link}
              target="_blank"
              rel="noreferrer"
            >
              {CapitalizeString(title)}
            </a>
          ) : internal_link ? (
            <LangLink className={styles.ContentText} to={internal_link}>
              {CapitalizeString(title)}
            </LangLink>
          ) : (
            <span className={styles.ContentText}>
              {CapitalizeString(title)}
            </span>
          )
        }
        placement="start"
        color={COLORS.primary}
        className={styles.Title}
      >
        <div className="mt-9 flex flex-column">{children}</div>
        </Badge.Ribbon>
    </StyledDiv>
  );
};

export default ContentItem;
